<!--    Modal for creating and editing Devices  -->
<!--Copy right - © 2024 tecera gmbh-->

<script>
    import { fly, fade } from "svelte/transition";
    import {
    all_devices,
        all_hymos,
        modal_mode,
        selected_device,
        toast_message,
    } from "../../stores.js";
    import { BASE_API_URL } from "../../config.js";
    import VehicleModalInputField from "./form_parts/VehicleModalInputField.svelte";
    import ToggleButton from "../buttons/ToggleButton.svelte";
    import ConfirmModal from "./ConfirmModal.svelte";
    import { tick } from "svelte";

    export let is_open; // status of the modal (open/closed)
    export let all_vehicles;    // all vehicles from the API


    
    // data for fields
    let vehicle_name = null;
    let vehicle_comment = null;

    // modal input fields
    let vehicle_name_field = {
        id: "vehicle_name",
        placeholder: "Bezeichnung",
        required: true,
        name:"name",
    };
    
    let vehicle_comment_field = {
        id: "vehicle_comment",
        placeholder: "Ergänzung",
        required: false,
        name:"comment",
    };
    
    let selected_vehicle; // the selected vehicle object

    let title;  // modal title ( will be set depending on create/edit mode)
    let is_device_active = true; // deviceconfig active status. true by default, but changed to the value of the actual config object
    let is_confirm_modal_open = false; // whether the confirm modal is open
    let confirm_modal_title =
        "Sind Sie sicher, dass Sie dieses Fahrzeug löschen möchten?"; // title for the confirm modal
    let is_dropdown_open = false; // determines whether the dropdown is open or not
    let is_modal_closable = false; // determines whether the modal can be closed
    let is_button_disabled = false; // whether the button is disabled or not

    // reactivity to open and close the modal with delay
    $: {
        if (is_open) {
            document.body.style.overflow = "hidden";
            document.body.classList.add("modal-open");
            setTimeout(() => {
                is_modal_closable = true; // 250ms delay to prevent closing the modal immediately
            }, 250);
        } else {
            setTimeout(() => {
                document.body.style.overflow = "auto";
                document.body.classList.remove("modal-open");
            }, 350); // enable scrolling after the modal is closed
        }
    }

    /**
     * Function to clear all input fields
     */
    function clear_all_inputs() {
        vehicle_name = null;
        vehicle_comment = null;
    }
    
    /**
     * Closes the modal if it is open and can be closed
    */
    function close_modal() {
        if (is_modal_closable) {
            is_open = false;
            $modal_mode = "closed";
            is_modal_closable = false;
        }
    }

    /**
     * Function to set a timeout for the button to prevent multiple clicks
     */
    function set_timeout_button(){
        is_button_disabled = true;
        setTimeout(() => {
            is_button_disabled = false;
        }, 500);
    }

    /**
     * Function to get the form data depending on the modal mode
     */
    function get_form_data() {
        if ($modal_mode === "create") {
            title =  "Fahrzeug anlegen";
            clear_all_inputs();
            selected_vehicle = null;
            is_device_active = true;
        } else if ($modal_mode === "edit" && $selected_device) {
            selected_vehicle = $selected_device;
            title = "Fahrzeug editieren";
            vehicle_name = $selected_device.vehicle_config[0].name;
            vehicle_comment = $selected_device.vehicle_config[0].comment;
            is_device_active = $selected_device.vehicle_config[0].active;
        }
    }

    // reactivity to fetch correct data or clear inputs
    $: if (is_open) {
        get_form_data();
    }

    let form;

    /**
     * Save the device to the API
     * @param {Event} event - The event object
    */
    async function save_device(event) {
        set_timeout_button();
        let form_data = Object.fromEntries(new FormData(form)); // aquire form data
        let vehicle_id = selected_vehicle.device.id; // get the id of the selected vehicle        
        let url_extension = `/vehicles/${vehicle_id}/configs/`;
        let request_url = BASE_API_URL + url_extension;

        try {
            const response = await fetch(request_url, {
                method: "POST",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(form_data),
            });
            //TODO: check this
            if (response.status !== 201) {
                handle_bad_response(response);
                return false;
            }

            let data = await response.json();
            selected_vehicle.vehicle_config.push(data);
            all_vehicles = [...all_vehicles];
            $selected_device = selected_vehicle;
            close_modal();
            $toast_message = " Fahrzeug erfolgreich angelegt";
            return true;
        } catch (error) {
            return false;
        }
    }

    /**
     * Update the device in the API.
     * @param {Event} event - The event object
    */
    async function update_device(event) {
        set_timeout_button();
        let form_data = Object.fromEntries(new FormData(form)); // aquire form data
        let vehicle_id = selected_vehicle.device.id; // get the id of the selected vehicle
        let vehicle_config_id = selected_vehicle.vehicle_config[0].id; // get the id of the selected vehicle config       
        let url_extension = `/vehicles/${vehicle_id}/configs/${vehicle_config_id}/`;
        let request_url = BASE_API_URL + url_extension;

        try {
            const response = await fetch(request_url, {
                method: "PUT",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(form_data),
            });
            //TODO: check this
            if (response.status !== 200) {
                handle_bad_response(response);
                return false;
            }

            let data = await response.json();

            // This NEEDS to be here, because svelte has problems updating nested arrays on the DOM
            selected_vehicle.vehicle_config.pop();
            all_vehicles = [...all_vehicles];
            await tick();
            selected_vehicle.vehicle_config.push(data);
            all_vehicles = [...all_vehicles];

            close_modal();

            $toast_message = "Fahrzeug erfolgreich editiert";
            return true;
        } catch (error) {
            return false;
        }
    }

    // TODO: implement
    async function delete_device() {
        return;
        set_timeout_button();

        let device_config_id = $selected_device.id;
        let url_extension = `/hymo_configs/${device_config_id}/`;
        let request_url = BASE_API_URL + url_extension;
        try {
            const response = await fetch(request_url, {
                method: "DELETE",
                headers: {
                    Authorization: `Token ${sessionStorage.getItem(
                        "2kai_access_token",
                    )}`,
                    "Content-Type": "application/json",
                },
            });
            if (!response.ok) {
                handle_bad_response(response);
                return false;
            }
            let data = await response.json();

            close_modal();
            get_free_hymos(hymo_group);
            $toast_message = " Gerät erfolgreich gelöscht";

            let idToFind = device_config_id;
            let index = $all_hymos.findIndex(
                (device_config) => device_config.id == idToFind,
            );
            if (index !== -1) {
                $all_hymos.splice(index, 1);
            }
            $all_hymos = $all_hymos;
            $selected_device = $all_hymos[0];
            return true;
        } catch (error) {
            return false;
        }
    }

    function select_vehicle(vehicle) {
        selected_vehicle = vehicle;
        is_dropdown_open = false;
    }

    function handleMenuOpen() {
        if (is_dropdown_open) {
            is_dropdown_open = false;
            document.body.removeEventListener("click", handleMenuClose);
        } else {
            is_dropdown_open = true;
            document.body.addEventListener("click", handleMenuClose);
        }
    }
    function handleMenuClose() {
        is_dropdown_open = false;
        document.body.removeEventListener("click", handleMenuClose);
    }
    let amount_of_free_vehicles = 0;
    $:amount_of_free_vehicles = all_vehicles.filter((vehicle)=>{
        return vehicle.vehicle_config.length == 0;
    }).length;
</script>


{#if is_open}
    <div
        class="svelte-modal svelte-backdrop"
        tabindex="-1"
        role="dialog"
        on:mousedown|self={() => close_modal()}
        on:keydown={(e) => {
            if (e.key === "Escape") {
                close_modal();
            }
        }}
        transition:fade={{ duration: 150 }}
    >
        <div
            class="modal-dialog modal-dialog-centered"
            role="document"
            in:fly={{ y: -400, duration: 350, delay: 100 }}
            out:fly={{ y: -400, duration: 350 }}
        >
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="deleteTilte">
                        {title}
                    </h5>
                    <button
                        type="button"
                        class="close"
                        on:click={() => close_modal()}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <!-- Modal Body -->
            <form bind:this={form} on:submit|preventDefault={(event) => $modal_mode == "create" ? save_device(event) : update_device(event)}>
                <div class="modal-body">
                    <div class="input-group mb-0 mt-2">
                        <div class="input-group mb-2 mt-2">
                            {#if $modal_mode == "create"}
                                {#if amount_of_free_vehicles == 0}
                                    <button
                                        class="btn btn-normal btn-transparentBlack btn-block dropdown-toggle"
                                        id="geraete_id"
                                        type="button"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                        disabled="true"
                                    >
                                        Keine freien Fahrzeuge vorhanden
                                    </button>
                                {:else}
                                    <button
                                        class="btn btn-normal btn-transparentBlack btn-block dropdown-toggle"
                                        id="geraete_id"
                                        type="button"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                        on:click|stopPropagation={handleMenuOpen}
                                    >
                                        {selected_vehicle
                                            ? selected_vehicle.device.dev_eui
                                            : "Fahrzeug wählen"}
                                    </button>
                                {/if}
                            {:else}
                                <button
                                    class="btn btn-normal btn-transparentBlack btn-block dropdown-toggle"
                                    id="geraete_id"
                                    type="button"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                    disabled="true"
                                >
                                    {#if $selected_device}
                                        {selected_vehicle.device.dev_eui}
                                    {/if}
                                </button>
                            {/if}

                            <div
                                class="dropdown-menu svelte-dropdown filter_dropdown mt-2 {is_dropdown_open
                                    ? 'show'
                                    : ''}"
                                aria-labelledby="geraete_id"
                            >
                                <div
                                    class="filter_dropdown_scrollable"
                                    id="alle_geraete_ids"
                                >
                                    {#each all_vehicles as vehicle}
                                    {#if vehicle.vehicle_config.length == 0}
                                        <button
                                            type="button"
                                            class="btn btn-transparent btn-block dropdown__checkbox"
                                            value={vehicle.device.dev_eui}
                                            name="vehicle"
                                            on:click={() => select_vehicle(vehicle)}
                                            >{vehicle.device.dev_eui}</button
                                        >
                                    {/if}
                                    {/each}
                                </div>
                            </div>
                        </div>
                        <VehicleModalInputField
                            field_data={vehicle_name_field}
                            bind:input_value={vehicle_name}
                        />
                        <VehicleModalInputField
                            field_data={vehicle_comment_field}
                            bind:input_value={vehicle_comment}
                        />
                        <ToggleButton
                            id="aktiv"
                            label="Aktiv"
                            bind:toggle={is_device_active}
                            classes={"mt-2"}
                            name="active"
                        />
                    </div>
                </div>
                <!-- Modal Footer -->
                <div class="modal-footer mt-2">
                    <!-- {#if $modal_mode == "edit"}
                        <button
                            type="button"
                            class="btn btn-danger mr-auto"
                            on:click={() => (is_confirm_modal_open = true)}
                            >Löschen</button
                        >
                    {/if} -->
                    <button
                        type="button"
                        class="btn btn-secondary"
                        on:click={() => close_modal()}>Abbrechen</button
                    >
                    {#if $modal_mode == "create"}
                        <button
                            type="submit"
                            class="btn btn-primary"
                            disabled={!selected_vehicle || is_button_disabled}
                            >Speichern</button
                        >
                    {:else}
                        <button
                            type="submit"
                            class="btn btn-primary"
                            disabled={is_button_disabled}
                            >Speichern</button
                        >
                    {/if}
                </div>
                </form>
            </div>
        </div>
    </div>
    <ConfirmModal
        bind:show_modal={is_confirm_modal_open}
        title={confirm_modal_title}
        on:confirm={() => delete_device()}
    />
{/if}
